import * as React from 'react';

import styles from '../styles.module.scss';

const Description: React.FC = () => {

	return (
		<div className={styles['notification-settings__description']}>
			<div className="m-b-xs">
				Add emails to send <b>weekly</b> notifications regarding company revenues.
			</div>
		</div>
	);
};

export default React.memo(Description);
